import BaseActionAbstract from 'cio/app-models/action-abstracts/base';
import { computed, set } from '@ember/object';
import { task } from 'ember-concurrency';

const EDITABLE_PROPERTIES = ['name', 'preconditions', 'addToSeg'];

const DIRTY_TRACKED_PROPERTIES = ['name', 'preconditions', 'addToSeg'];

const DIRTY_DEPENDENCIES = `action.{${DIRTY_TRACKED_PROPERTIES.join(',')}}`;

export default BaseActionAbstract.extend({
  type: 'manual_segment_update',

  action: null,
  actionType: null,

  _editableProperties: EDITABLE_PROPERTIES,
  _dirtyDependencies: DIRTY_DEPENDENCIES,

  name: null,
  preconditions: null,
  segmentId: null,
  addToSeg: null,

  _isDirty: computed('segmentId', 'action.segment.id', function () {
    if (this.segmentId != null) {
      return this.segmentId !== this.action.belongsTo('segment').id();
    }
    return;
  }),

  prepareForEdit() {
    this._super(...arguments);

    set(this, 'segmentId', this.action.belongsTo('segment').id());
  },

  async prepareForSave() {
    let action = this._super(...arguments);

    let { segmentId } = this;
    if (segmentId != null) {
      let { store } = action;
      action.set('segment', store.peekRecord('segment', segmentId) ?? (await store.findRecord('segment', segmentId)));
    }

    return action;
  },

  rollback() {
    this.prepareForEdit();
  },

  // eslint-disable-next-line require-yield
  saveTask: task(function* () {
    let action = yield this.prepareForSave();

    try {
      let response = yield action.save();
      this.prepareForEdit();
      return response;
    } catch (e) {
      action.rollbackAttributes();
      throw e;
    }
  }).drop(),

  // eslint-disable-next-line require-yield
  deleteTask: task(function* () {
    return this.action.campaign.removeActionFromWorkflow(this.action);
  }).drop(),
});
